import { EJoinType, IGenericSelectDataModel, IGenericSelectRelationsModel } from "@kuika/kuika-cl-model";
import _ from "lodash";
import * as React from "react";
import KuikaSelectbox from "../../../../ui-kit/kuika-selectbox/kuika-selectbox";
import KuikaSvg from "../../../../ui-kit/kuika-svg/kuika-svg";
import KuikaTable, { KuikaTableColumn } from "../../../../ui-kit/kuika-table/kuika-table";
import KuikaText from "../../../../ui-kit/typography/Text/Text";

export interface IJoinTableListState {}

export interface IJoinTableListProps {
  selectData: IGenericSelectDataModel;
  updateSelectData: (newData: IGenericSelectDataModel) => void;
}

const joinTypeOptions = [
  {
    value: EJoinType.leftJoin,
    label: (
      <>
        <KuikaSvg name="left-join" width={16} height={16} />
        <KuikaText>Left Join</KuikaText>
      </>
    )
  },
  {
    value: EJoinType.rightJoin,
    label: (
      <>
        <KuikaSvg name="right-join" width={16} height={16} />
        <KuikaText>Right Join</KuikaText>
      </>
    )
  },
  {
    value: EJoinType.innerJoin,
    label: (
      <>
        <KuikaSvg name="inner-join" width={16} height={16} />
        <KuikaText>Inner Join</KuikaText>
      </>
    )
  },
  {
    value: EJoinType.fullOuterJoin,
    label: (
      <>
        <KuikaSvg name="outer-join" width={16} height={16} />
        <KuikaText>Outer Join</KuikaText>
      </>
    )
  }
];

class JoinTableList extends React.PureComponent<IJoinTableListProps, IJoinTableListState> {
  constructor(props: IJoinTableListProps) {
    super(props);
    this.state = {};
  }

  handleUpdateRelationJoinType = (joinType: EJoinType, index: number) => {
    const selectData = _.cloneDeep(this.props.selectData);
    selectData.relations[index].joinType = joinType;
    this.props.updateSelectData(selectData);
  };

  getColumns = (): KuikaTableColumn<IGenericSelectRelationsModel & { _index: number }>[] => {
    return [
      {
        id: "toTable",
        header: () => "To Table",
        cell: (row) => (
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <KuikaSvg name="table" width={16} height={16} />
            <KuikaText>{row.toTableSchema ? `${row.toTableSchema}.${row.toTable}` : row.toTable}</KuikaText>
            <KuikaText style={{ color: "var(--dark-5)" }}>[{row.toPk}]</KuikaText>
          </div>
        )
      },
      {
        id: "joinType",
        header: () => "Join Type",
        cell: (row) => (
          <KuikaSelectbox
            className="kuika-selectbox--no-border"
            value={row.joinType}
            onChange={(val) => this.handleUpdateRelationJoinType(val, row._index)}
            options={joinTypeOptions}
          />
        ),
        width: 120
      },
      {
        id: "fromTable",
        header: () => "From Table",
        cell: (row) => (
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <KuikaSvg name="table" width={16} height={16} />
            <KuikaText>{row.fromTableSchema ? `${row.fromTableSchema}.${row.fromTable}` : row.fromTable}</KuikaText>
            <KuikaText style={{ color: "var(--dark-5)" }}>[{row.fromFk}]</KuikaText>
          </div>
        )
      }
    ];
  };

  render() {
    const dataWithIndex = this.props.selectData.relations.map((relation, idx) => ({
      ...relation,
      _index: idx
    }));

    return (
      <KuikaTable
        data={dataWithIndex}
        columns={this.getColumns()}
        rowKey={(row) => `${row.toTable}-${row.fromTable}-${row._index}`}
        enablePagination={false}
        emptyTitle="No relations"
        emptyDescription="Add a join to create relations between tables"
      />
    );
  }
}

export const JoinTableListComponent = JoinTableList;
